import React, {Component} from 'react';
import axios from "axios";

import classes from './PatternConsequencesInput.module.css';
import apiUrl from "../../../shared/config";
import NewPatternConsequence from "../NewPatternConsequence/NewPatternConsequence";
import PatternConsequenceInput from "../../UI/PatternConsequenceInput/PatternConsequenceInput";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

class PatternConsequencesInput extends Component  {
    state = {
        pattern_consequences: [],
        selected_pattern_consequences: [],
        new_pattern_consequence: false
    };

    componentDidMount() {
        if (this.state.pattern_consequences !== []) {
            axios.get(apiUrl +'PatternConsequences/getPatternConsequences')
                .then(response => {
                    this.setState({pattern_consequences: response.data});
                });
        }
        this.setState({selected_pattern_consequences: this.props.patternConsequences});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.patternConsequences !== this.props.patternConsequences) {
            this.setState({selected_pattern_consequences: this.props.patternConsequences})
        }
    }

    newPatternConsequenceToggle = () => {
        this.setState({new_pattern_consequence: !this.state.new_pattern_consequence});
    };

    newPatternConsequencesHandler = (new_pattern_consequence_add) => {
        this.props.patternConsequencesUpdate(
            [...this.state.selected_pattern_consequences, new_pattern_consequence_add].map((consequence) => {
                return {value: consequence.consequence_id, label: consequence.consequence_title, description: consequence.consequence_description}
            })
        );
        this.setState({
            pattern_consequences: [...this.state.pattern_consequences, new_pattern_consequence_add],
        });
    };

    render() {

        let pattern_consequences_input_element= (
            <React.Fragment>
                <dd className="col-sm-9">
                    <PatternConsequenceInput
                        pattern_consequences={this.state.pattern_consequences}
                        pattern_consequence_filter={this.state.selected_pattern_consequences.map(consequence => consequence.consequence_id)}
                        patternConsequencesUpdate={this.props.patternConsequencesUpdate}
                        updatePage={this.props.updatePage}
                        closePatternDetails={this.props.closePatternDetails}
                    />
                </dd>
                <dt className="col-sm-3"></dt>
            </React.Fragment>
        )

        let new_pattern_consequence_jsx = '';
        if (this.state.new_pattern_consequence === true) {
            new_pattern_consequence_jsx = (<NewPatternConsequence
                pattern_consequences={this.state.pattern_consequences}
                newPatternConsequenceToggle={this.newPatternConsequenceToggle}
                onNewPatternConsequence={this.newPatternConsequencesHandler}
                token={this.props.token}
                userId={this.props.userId}
            />);
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Consequences</label></dt>
                {pattern_consequences_input_element}
                {new_pattern_consequence_jsx}
                {!this.state.new_pattern_consequence ? <dd className="col-sm-9" style={{display: "inline-flex", justifyContent: "right"}}>
                    <span>
                        Enter New Consequence: <AddCircleOutlineIcon
                                onClick={this.newPatternConsequenceToggle}
                                className={classes.AddButton}
                            />
                    </span>
                </dd> : ''}
            </dl>
        );
    }
}

export default PatternConsequencesInput;